import Pusher from 'pusher-js'
import { Env } from '@/util/Env'

Pusher.log = (msg) => {
  // console.log(msg)
}

const { keys } = Env()

export default (app) => {
  const { pusherKey, pusherCluster } = keys(['PUSHER_KEY', 'PUSHER_CLUSTER'])

  app.config.globalProperties.pusher = new Pusher(pusherKey, {
    cluster: pusherCluster,
    encrypted: true,
    forceTLS: true
  })
}
